import {
  type HistoryOptions,
  parseAsString,
  useQueryStates,
} from '@vrplatform/query-params';
import { removeDrawerStateFromUrl } from '../../utils';

export function useDepositDetailDrawer() {
  const [opts, set] = useQueryStates({
    deposit: parseAsString,
  });

  return {
    opened: !!opts.deposit,
    open: (id: string, type?: HistoryOptions) => {
      removeDrawerStateFromUrl();
      set(
        { deposit: id },
        {
          history: type || 'push',
        }
      );
    },
    close: () => set(null),
    depositId: opts.deposit,
  };
}
